import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useAtomValue } from 'jotai';
import { GameButton } from '@/components/GameButton';
import { useForceUpdate } from '../hooks/useForceUpdate';
import { isUpdateRequiredState } from '../state';

export const ForceUpdateDialog = () => {
  useForceUpdate();
  const isUpdateRequired = useAtomValue(isUpdateRequiredState);

  return (
    <Dialog open={isUpdateRequired} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        アプリの更新
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center', mb: 1 }}>
          新しいバージョンが利用可能です。
        </DialogContentText>
        <DialogContentText sx={{ textAlign: 'center' }}>
          続けるにはページを更新してください。
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <GameButton
          onClick={() => window.location.reload()}
          variant='primary'
          size='lg'
          startIcon={<SystemUpdateAltIcon />}
          sx={{ minWidth: 160 }}
        >
          更新する
        </GameButton>
      </DialogActions>
    </Dialog>
  );
};
